import { apiClient } from '@/utils/api-client'

const API_INTERNAL_BASE = '/profile'

/**
 * Profile service for updating user profile information.
 */
class ProfileService {
    /**
     * Update the current user's profile.
     *
     * @param {Object} form - Profile update payload
     * @returns {Promise<Object>} Updated profile response
     */
    async update(form) {
        return await apiClient.put(API_INTERNAL_BASE, form).then((response) => {
            return response.data
        })
    }
}

export default new ProfileService()
